<template>
	<div class="orderpay">
		<el-dialog :visible.sync="showorderpay" :title="title" width="500px" :close-on-click-modal="false" lock-scroll
			:show-close="true" :append-to-body="true">
			<div  id="orderpay">
				<el-row style="margin-bottom:100px;margin-right:20px;">
					<el-col :span="9" v-for="(item,index) in paylist" :key="index" style="margin-top:10px">
						<el-radio @input="changepaytype(index)" v-model="checkedpaytype"
							:label="item.d_value">{{item.d_name}}</el-radio>
						<el-image v-if="item.remark!=''" style="width: 100px; height: 100px" :src="item.remark"
							fit="fill"></el-image>
					</el-col>
				</el-row>
				<span slot="footer">
					<div style="text-align:center;">
						<el-button @click="paycallback(0)" size="mini">取 消</el-button>
						<el-button type="success" @click="gopay" size="mini" :disabled="suredisabled">确 定</el-button>
					</div>
				</span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Utils from '../../lib/util.js';
	export default {
		components: {

		},
		props: {

		},
		data() {
			return {
				showorderpay: false,
				title: '收银台',
				paylist: [],
				checkedpaytype: '',
				type: '',
				pkval: '',
				divclass: 'orderpay',
				suredisabled:false,
				userid:''
			};
		},
		methods: {
			init(param) {
				if (param.pkval != undefined)
					this.pkval = param.pkval;
				if (param.ratebatch != undefined)
					this.ratebatch = param.ratebatch;
				if (param.userid != undefined)
					this.userid = param.userid;	
				if (this.pkval != '' && this.ratebatch != '') {
					this.showorderpay = true;
					this.GetPaytype();
				} else
					this.$tool.message('打开收银台失败', 0);
			},
			GetPaytype() {
				var that = this;
				this.$apipost.get.dic({
					type: '支付方式'
				}).then(res => {
					if (res != '') {
						that.paylist = res.list;
						if (res.list.length > 0) {
							that.changepaytype(0);
						}
					}
				});
			},
			gopay() {
				if (this.checkedpaytype == '') {
					this.$tool.message('请选择支付方式', 0);
					return false;
				}
				var that = this;
				var paraminfo = {
					paytype: this.checkedpaytype,
					type: this.type,
					pkval: this.pkval,
					ratebatch: this.ratebatch
				}
				this.$tool.loading2('正在支付', this.divclass);
				this.suredisabled=true;
				this.$apipost.post.OrderPay({
					paraminfo: paraminfo
				}).then(res => {
					that.suredisabled=false;
					if (res != '') {
						if (res.state == '1') {
							//支付成功
							this.$tool.loadingclose();
							this.$tool.message('支付成功', 1);
							that.paycallback(1);
						} else if (res.state == '2') {
							//第三方支付，创建支付订单
							that.goonlinepay(res,5);
						} else if (res.state == '0') {
							this.$tool.loadingclose();
							this.$tool.message(res.message, 0);
						}
					}
				});
			},
			//选中值
			changepaytype(index) {
				this.type = this.paylist[index].d_property;
				this.checkedpaytype = this.paylist[index].d_value;
			},
			paycallback(ispay) {
				this.showorderpay = false;
				this.$emit('paycallback', {
					ispay: ispay
				});
			},
			goonlinepay(re,times) {
				var that = this;
				var paraminfo = {
					pkval: that.pkval,
					paytype: re.type,
					ratebatch: that.ratebatch,
					
				}
				if(this.userid!=''){
					paraminfo.userid=this.userid;
				}else{
					paraminfo.token=localStorage.getItem('token');
				}
				this.$apipost.post.CreatePayOrder({
					paraminfo: paraminfo
				}).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						if (res.state == '1') {
							if (res.payurl != undefined&&res.payurl!=null&&res.payurl!='') {
								//跳转到支付页
								this.$tool.OpenFile(this, res.payurl);
								that.ShowPaySuccess();
							} else if(res.remark != undefined&&res.remark!=null&&res.remark!='') {
								//返回的是支付网页html源码
								that.ShowPaySuccess();
							}
							else{
								if(times>0){
									times=times-1;
									that.goonlinepay(re,times);
								}else{
									this.$tool.message('支付异常，请重试', 0);
									that.paycallback(0);
								}
							}
						} else
							this.$tool.message(res.message, 0);
					}
				});
			},
			ShowPaySuccess() {
				var that = this;
				this.$confirm('订单确认已经支付了吗?', '提示', {
				          confirmButtonText: '已完成支付',
				          cancelButtonText: '未支付',
				          type: 'warning'
				        }).then(() => {
				          that.CheckPayState();
				        }).catch(() => {
							that.CheckPayState();
				        });
				      
			},
			CheckPayState() {
				var that = this;
				var paraminfo = {
					pkval: this.pkval,
					ratebatch: this.ratebatch
				}
				this.$tool.loading2('正在检测支付状态', this.divclass);
				this.$apipost.post.CheckOrderPayState({
					paraminfo: paraminfo
				}).then(res => {
					this.$tool.loadingclose();
					//debugger
					if (res.state == '1') {
						that.paycallback(1);
					} else if (res.state == '2') {
						this.$tool.message('订单未支付', 0);
						that.paycallback(0);
					} else {
						this.$tool.message('订单支付异常', 0);
						that.paycallback(0);
					}
				}).catch(e => {
					that.CheckPayState();
				});
			}
		}
	}
</script>

<style>
</style>